import React, { useContext, useEffect, useState } from 'react'
import MediaTypeEnum from '../../enums/MediaType'
import Video from '../Video/Video'
import Image from '../Image/Image'
import { DEFAULT_ALT_IMAGE } from '../../constants/DefaultAlts'
import Button from '../Button/Button'
import ButtonVariantEnum from '../../enums/ButtonVariant'
import useMediaQuery from '../../hooks/useMediaQuery'
import { deviceMax, deviceMin } from '../../theme/breakpoints'
import LayoutContext from '../../contexts/LayoutContext'
import HeadingGroup from '../HeadingGroup/HeadingGroup'
import GridContainer from '../GridContainer/GridContainer'
import {
  StyledGridContainer,
  StyledHeroBasicHeaderContent,
  StyledHeroBasicHeaderVideo,
  StyledHeroHeaderWrapper,
  StyledIFrame,
  StyledViewportContainer,
} from './HeroNewHeader.styled'
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs'
import HeroVariantEnum from '../../enums/HeroVariant'
import useCtaLink from '../../hooks/useCtaLink'
import RoutingEnum from '../../routes/appRoutes'
import FooterModal from '../FooterModal/FooterModal'


const MEDIA_CENTER_BTN_LABEL = 'Media Center'
const SUBSCRIBE_BTN_LABEL = 'Subscribe to alerts'
const KALEIDOSCOPE =
  'https://api.kscope.io/ks-ir?key=9e74551c-e101-11ec-853f-0ed8406b0c25&content=stocksm'
const KALEIDOSCOPE_TITLE = 'Results'

const HeroNewHeader = (props) => {
  const {
    header,
    isBreadcrumbsHidden,
    isFullMediaHero = false,
    pathname,
    onlyBreadcrumbs = false,
    slug,
    title,
    type,
    variant = HeroVariantEnum.regular,
  } = props

  if(variant === HeroVariantEnum.news) {
    header.primaryCta = {
      label: `${MEDIA_CENTER_BTN_LABEL}`,
      url: `${RoutingEnum.mediaCenter}`
    }
    header.tertiaryCta = {
      label: `${SUBSCRIBE_BTN_LABEL}`,
    }
  }


  const isDesktop = useMediaQuery(deviceMin.laptop)
  const isMobile = useMediaQuery(deviceMax.mobileL)
  const [show, setShow] = useState(false)

  const [primaryCtaUrl, primaryCtaSlug] =  useCtaLink(header?.primaryCta?.url)
  const [secondaryCtaUrl, secondaryCtaSlug] =  useCtaLink(header?.secondaryCta?.url)

  const isFullMedia = isFullMediaHero || header?.sys?.contentType?.sys?.id === 'headerFullMedia'
  const media = isDesktop ? (isFullMedia ? header?.mediaDesktop : header?.media) : header?.mediaMobile

  const { setNavOpacity } = useContext(LayoutContext)

  useEffect(() => {
    setNavOpacity(media)
  }, [media])


  if (!header.title) {
    return null
  }

  return (
    <div>
      <FooterModal
        show={show}
        isMobile={isMobile}
        onClose={() => {
          setShow(false)
        }}
      />

      {!isBreadcrumbsHidden && variant !== HeroVariantEnum.home && (
        <Breadcrumbs
          pathname={pathname}
          slug={slug}
          title={title}
          type={type}
        />
      )}

      {!onlyBreadcrumbs && <StyledHeroHeaderWrapper isFullMedia={isFullMedia}>
        <StyledViewportContainer isFullMedia={isFullMedia}>
          <StyledGridContainer columns={{ base: 1, laptop: 2 }}>
            <StyledHeroBasicHeaderContent isFullMedia={isFullMedia}>
              <HeadingGroup
                titleLevel={1}
                titleLabel={title}
                subtitleLabel={header?.subtitle}
              />

              {(header?.primaryCta || header?.secondaryCta) && <GridContainer
                className='mt-24 laptop:mt-32'
                columns={{ base: 1, laptop: 2 }}
                gap={24}
              >
                {header?.primaryCta && (
                  <Button
                    label={header.primaryCta.label}
                    to={primaryCtaSlug}
                    href={primaryCtaUrl}
                    variant={ButtonVariantEnum.primary}
                    contactEmail={header?.primaryCta?.contactEmail}
                    target={primaryCtaUrl ? '_blank' : null}
                  />
                )}

                {header?.secondaryCta && (
                  <Button
                    label={header.secondaryCta.label}
                    to={secondaryCtaSlug}
                    href={secondaryCtaUrl}
                    variant={ButtonVariantEnum.secondary}
                    contactEmail={header.secondaryCta?.contactEmail}
                    target={secondaryCtaUrl ? '_blank' : null}
                  />
                )}

                {header?.tertiaryCta && (
                  <Button
                    label={header.tertiaryCta.label}
                    onClick={() => setShow(true)}
                    variant={ButtonVariantEnum.secondary}
                  />
                )}
              </GridContainer>}
            </StyledHeroBasicHeaderContent>
            {variant === HeroVariantEnum.investor && (
              <StyledIFrame
                src={KALEIDOSCOPE}
                title={KALEIDOSCOPE_TITLE}
              ></StyledIFrame>
            )}
            {(isFullMedia || isDesktop) && (
              <StyledHeroBasicHeaderVideo $isFullMedia={isFullMedia}>
                {/*ContentfulAsset Image*/}
                {media?.contentfulAsset && (
                  <>
                    {media?.contentfulAsset?.file?.contentType === MediaTypeEnum.mp4 ? (
                      <Video
                        url={media.contentfulAsset.url}
                        withControls={false}
                      />
                    ) : (
                      <Image
                        alt={media.altText?.altText || DEFAULT_ALT_IMAGE}
                        image={media.contentfulAsset.gatsbyImageData}
                      />
                    )}
                  </>
                )}
                {media?.cloudinaryAsset && (
                  <>
                    {/*CloudinaryAsset Video*/}
                    {media.cloudinaryAsset[0]?.resource_type === MediaTypeEnum.video && (
                      <Video
                        url={media.cloudinaryAsset[0].secure_url}
                        withControls={false}
                      />
                    )}
                    {/*CloudinaryAsset Image*/}
                    {media.cloudinaryAsset[0].resource_type === MediaTypeEnum.image && (
                      <Image
                        alt={
                          media.cloudinaryAsset[0].context?.custom.alt ||
                          media.altText?.altText ||
                          DEFAULT_ALT_IMAGE
                        }
                        absolutePath={media.cloudinaryAsset[0].secure_url}
                      />
                    )}
                  </>
                )}
              </StyledHeroBasicHeaderVideo>
            )}
          </StyledGridContainer>
        </StyledViewportContainer>
      </StyledHeroHeaderWrapper>}
    </div>
  )
}

export default HeroNewHeader